import { useEffect, useRef, useState } from 'react'

import { DSButton, DSCircularLoading, DSModal, DSText } from '@vr/ds-react'
import { FormProvider, useForm } from 'react-hook-form'

import { Justification } from '../justification'
import ModalError from '@/components/modal-error'
import { useGeneralContext } from '@/contexts/general.context'
import { useRemove } from '@/hooks/use-remove'

type FormValues = {
  justificativa: string
}

const ModalRemove = ({
  ids,
  onClose = () => {},
  onSuccess
}: {
  ids: string[]
  onClose?: () => void
  onSuccess?: () => void
}) => {
  const [accountKey, setAccountKey] = useState(Date.now())
  const formRef = useRef<HTMLFormElement>(null)
  const [modalError, setModalError] = useState(false)
  const { handleFilter, currentFilters } = useGeneralContext()
  const { removeItems, isLoading } = useRemove()

  const userString = localStorage.getItem('user')
  const user = userString ? JSON.parse(userString) : {}
  const userId = user?.userId

  const methods = useForm<FormValues>({
    defaultValues: {
      justificativa: ''
    }
  })

  useEffect(() => {
    setAccountKey(Date.now())
  }, [])

  const onSubmit = async (data: FormValues) => {
    const response = await removeItems({
      idsItens: ids,
      alteradoPor: userId,
      motivoRemocao: data.justificativa
    })

    if (response?.sucesso) {
      handleFilter(currentFilters)
      onSuccess?.()
      onClose()
      return
    }

    setModalError(true)
  }

  return (
    <>
      <DSModal config={{ show: true, onClose }} css={{ width: '500px' }}>
        <FormProvider {...methods}>
          <form
            id='form-remove'
            onSubmit={methods.handleSubmit(onSubmit)}
            ref={formRef}
          >
            <DSModal.Header onClose={onClose}>Remover</DSModal.Header>
            <DSModal.Body>
              {isLoading ? (
                <DSCircularLoading isLoading shouldBlur={false} />
              ) : (
                <Justification methods={methods} accountKey={accountKey} />
              )}
            </DSModal.Body>
            <DSModal.Footer css={{ display: 'flex', justifyContent: 'center' }}>
              <DSButton variant='primary' type='submit'>
                Enviar
              </DSButton>
            </DSModal.Footer>
          </form>
        </FormProvider>
      </DSModal>

      <ModalError isOpen={modalError} title='Erro' onClose={onClose}>
        <DSText>
          Ocorreu um erro ao remover a solicitação. Por favor, tente novamente
          mais tarde.
        </DSText>
      </ModalError>
    </>
  )
}

export default ModalRemove
